import uniqBy from 'lodash/uniqBy'
import { isYesObjectRow } from './relationObjectsAtColumn'

export type RelationPatchEntry = { uuid: string }

/**
 * Collapses relation field values to UUID-only references for PATCH payloads.
 * The platform expects relation updates as `[{ uuid }, ...]`, not full nested objects.
 */
export function normalizeRelationArrayForPatch(
  value: unknown
): RelationPatchEntry[] {
  if (!Array.isArray(value)) {
    return []
  }

  const entries = value
    .filter(isYesObjectRow)
    .map((item) => ({ uuid: item.uuid }))

  return uniqBy(entries, 'uuid')
}
